// extracted by mini-css-extract-plugin
module.exports = {"TableItem__th":"TableItem_TableItem__th__coX5R","TableItem__td":"TableItem_TableItem__td__jwlyE"};